import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { Button, Text, makeStyles, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { loginRequest } from '../config/authConfig';
import { attemptSilentSignIn, shouldAttemptSilentSignIn } from '../services/silentSignIn';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    gap: tokens.spacingVerticalL,
  },
  title: {
    fontSize: tokens.fontSizeHero900,
    fontWeight: tokens.fontWeightSemibold,
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
  },
});

export default function LoginPage() {
  const styles = useStyles();
  const { instance } = useMsal();
  const { t } = useTranslation();

  // CNV-003: one silent attempt per tab session (see services/silentSignIn.ts). While it runs, App
  // shows its spinner; if it finds a Microsoft session the person is in, otherwise this page comes
  // back with the button and does not try again.
  useEffect(() => {
    if (shouldAttemptSilentSignIn()) void attemptSilentSignIn(instance);
  }, [instance]);

  const handleSignIn = () => {
    instance.loginRedirect(loginRequest).catch(console.error);
  };

  return (
    <div className={styles.page}>
      <Text className={styles.title}>{t('brand')}</Text>
      <Text className={styles.subtitle}>{t('loginPage.subtitle')}</Text>
      <Button appearance="primary" size="large" onClick={handleSignIn}>
        {t('loginPage.signIn')}
      </Button>
    </div>
  );
}
